import { useEffect } from 'react';

/**
 * Asks the browser to confirm a refresh or tab close while `isActive` is true.
 * The browser shows its own generic prompt; custom text is ignored by every modern browser.
 * In-app router navigation is not covered, pair it with react-router's <Prompt> when that matters.
 *
 * @param {boolean} isActive Whether leaving the page right now would lose work.
 */
const useBeforeUnloadGuard = (isActive) => {
  useEffect(() => {
    if (!isActive) {
      return undefined;
    }
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      // eslint-disable-next-line no-param-reassign
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [isActive]);
};

export default useBeforeUnloadGuard;
